export enum SocialPostStatusType {
  PendingApproval = 1,
  RequireUpdates = 2,
  Published = 3,
  Draft = 4,
  Scheduled = 5,
  Archived = 6,
  Error = 7
}
